import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { useStudent } from "@/context/StudentContext";
import { StudentAuthShell } from "./StudentLogin";
import { btnPrimary } from "@/components/portal/PortalUI";

export default function StudentMagic() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  const { setStudent } = useStudent();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post("/student/auth/magic-login", { token: params.get("token") || "" })
      .then((r) => { setStudent(r.data); navigate(r.data.needs_password ? "/student?setpw=1" : "/student"); })
      .catch((e) => setError(errMsg(e)));
  }, [params, navigate, setStudent]);

  return (
    <StudentAuthShell title="Signing you in…">
      {error ? (
        <div className="space-y-4"><p className="text-red-700 text-sm" data-testid="magic-error">{error}</p>
          <Link to="/student/login" className={`${btnPrimary} w-full`}>Back to Student Login</Link></div>
      ) : <p className="text-sm text-dark-text/60 animate-pulse">Verifying your secure link…</p>}
    </StudentAuthShell>
  );
}
